import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "submit", "error"];

  validate(event) {
    let isValid = this.inputTargets.some((input) => parseInt(input.value) > 0);

    this.submitTargets.forEach((button) => {
      if (isValid == button.disabled) {
        button.disabled = !isValid;
      }
    });

    if (isValid && !this.errorTarget.classList.contains("d-none")) {
      this.errorTarget.classList.add("d-none");
    } else if (!isValid && this.errorTarget.classList.contains("d-none")) {
      this.errorTarget.classList.remove("d-none");
    }
  }
}
